import { Fragment } from "react";
import Markdown from "markdown-to-jsx";
import classNames from "classnames";
import ContactForm from "./components/contactForm";
import Image from "components/imageNew/image";
import { NotepadSvg, SummitSvg } from "./svgIcons";
import type { NewsletterCompetitionPageData } from "./fetcher";

const innerContainerClasses = classNames(
  "mx-auto w-100 max-w-[1040px] px-5 lg:max-w-[1000px] lg:px-0"
);

const NewsletterCompetitionView = ({
  data,
}: {
  data: NewsletterCompetitionPageData;
}) => {
  const competitionTerms = [
    {
      text: data.entryInfoPoint1,
      image: <NotepadSvg />,
    },
    {
      text: data.entryInfoPoint2,
      image: <SummitSvg />,
    },
  ];

  return (
    <Fragment>
      <main className="w-full overflow-x-hidden bg-[#F4F4F6] pt-[65px] text-black-rock">
        <div
          className={classNames(
            innerContainerClasses,
            "pb-[30px] pt-[30px] md:pb-[60px] md:pt-[60px]"
          )}
        >
          <div className="flex w-full flex-col items-center">
            <h1 className="max-w-[750px] text-center font-recklessBold text-[32px] leading-[130%] md:text-[52px] [&_strong]:text-cerise">
              <Markdown>{data.heroTitle}</Markdown>
            </h1>
          </div>
        </div>
        <div className="w-full bg-white">
          <div
            className={classNames(
              innerContainerClasses,
              "flex flex-col items-center pb-[100px] pt-[30px] md:px-16 md:pt-[60px] lg:pb-0"
            )}
          >
            <div className="flex max-w-[750px] flex-col-reverse gap-x-10 lg:max-w-[unset] lg:flex-row">
              <div className="flex items-center justify-center lg:w-2/5">
                <Image
                  className="mt-5 aspect-square h-auto max-w-[180px] lg:mt-0 lg:max-w-[220px]"
                  src={
                    "https://www.datocms-assets.com/60124/1705572004-newsletter_daily-1.png"
                  }
                  alt="Newsletter Daily Logo"
                  sizes="(min-width: 1280px) 220px, 180px"
                />
              </div>
              <div className="lg:w-3/5">
                <p className="mb-[14px] font-recklessBold text-[18px] leading-[130%] md:text-[26px]">
                  {data.entryInfoHeading}
                </p>
                <div className="flex flex-col gap-y-2 md:gap-y-0">
                  {competitionTerms.map((term, index) => (
                    <div key={index} className="mb-1 flex items-center gap-x-5">
                      <div className="flex h-[62px] w-[62px] items-center justify-center">
                        {term.image}
                      </div>
                      <p className="text-[18px] leading-[130%] text-black-rock">
                        {term.text}
                      </p>
                    </div>
                  ))}
                </div>
                <p className="mt-4 text-[16px] leading-[130%]">
                  {data.entryInfoText}
                </p>
              </div>
            </div>

            <div className="w-[calc(var(--vw,_1vw)_*_100)] lg:mt-[56px] lg:bg-[#F4F4F6] lg:pb-12">
              <div className={classNames(innerContainerClasses)}>
                <div className="pt-[36px] lg:self-start lg:pt-[40px]">
                  <p className="font-recklessBold text-[18px] leading-[130%] text-cerise md:text-[26px]">
                    {data.newsletterInfoHeading}
                  </p>
                  <p className="mb-[35px] mt-5 text-[18px] leading-[130%] md:max-w-[750px] lg:max-w-full">
                    {data.newsletterInfoText}
                  </p>
                </div>

                <div className="w-full max-w-[600px] lg:self-start">
                  <p className="mb-4 font-recklessBold text-[18px] leading-[130%] md:text-[26px]">
                    {data.signUpText}
                  </p>
                  <ContactForm />
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </Fragment>
  );
};

export default NewsletterCompetitionView;
